<p-toast [style]="{marginTop: '80px'}"></p-toast>
<router-outlet></router-outlet>
<p-confirmDialog key="globalConfirm" header="Confirmação da ação" acceptLabel="Sim" rejectLabel="Não"
    icon="pi pi-exclamation-triangle"></p-confirmDialog>